import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "component", "unitCost", "totalCost"]

  connect() {
    this.calculate()
  }

  calculate() {
    // Sum all cost components for unit cost
    let unitCost = 0
    this.componentTargets.forEach(input => {
      unitCost += parseFloat(input.value) || 0
    })

    // Get quantity
    const quantity = parseInt(this.quantityTarget.value) || 0

    // Calculate total cost
    const totalCost = unitCost * quantity

    // Update display fields
    this.unitCostTarget.value = unitCost.toFixed(2)
    this.totalCostTarget.value = totalCost.toFixed(2)
  }
}
